import React from 'react';
import cn from 'clsx';

import StarRating from '../../library/star-rating/star-rating';
import Typography from '../../library/typography/typography';
import ProductBrandLogo from './components/product-brand-logo/product-brand-logo';
import ProductCode from './components/product-code/product-code';
import ProductGBB from '../product-gbb/product-gbb';
import ProductTitle from '../product-title/product-title';

import { getNormalizedGBB } from '../../shared/utils/product/product';

import { Maybe } from '../../shared/types/graphql-types';

import styles from './product-description.scss';

interface ProductContainsDescriptionProps {
  brand?: Maybe<string>;
  brandLogoUrl?: Maybe<string>;
  className?: string;
  code?: Maybe<string>;
  gbb?: Maybe<string>;
  isOE?: boolean;
  link?: Maybe<string>;
  name?: Maybe<string>;
  onClick?: () => void;
  productType?: Maybe<string>;
  showGBBTooltip?: boolean;
  showRating?: boolean;
  size?: Maybe<string>;
  subDescription?: Maybe<string>; //TODO: Remove this prop if OW-4656 can be completed by the backend
  totalRating?: number;
}

function ProductDescription(props: ProductContainsDescriptionProps) {
  const {
    brand,
    brandLogoUrl,
    className,
    code = '',
    gbb,
    isOE = false,
    link,
    name,
    onClick,
    showGBBTooltip,
    showRating = false,
    size,
    subDescription,
    totalRating
  } = props;

  return (
    <div
      className={cn(
        styles['description'],
        `${className || ''} product-description`
      )}
      data-testid="product-description"
      key={code}
    >
      {brandLogoUrl && (
        <ProductBrandLogo brand={brand} brandLogoUrl={brandLogoUrl} />
      )}
      <ProductTitle
        brand={brand}
        className={`product-description__title ${
          className ? `${className}__title` : undefined
        }`}
        link={link}
        name={name}
        onClick={onClick}
        size={size}
      />
      {subDescription && (
        <Typography className={styles['sub-description']} tag="span">
          {subDescription}
        </Typography>
      )}
      <div className="product-description__right-column">
        {code && <ProductCode code={code} />}
        <div
          className={cn(
            styles['product-tags'],
            'product-description__product-tags'
          )}
        >
          {gbb && (
            <div className={styles['gbb']}>
              <ProductGBB
                showGBBTooltip={showGBBTooltip}
                value={getNormalizedGBB(gbb)}
              />
            </div>
          )}
          {isOE && (
            <Typography
              className={styles['original-equipment-tire']}
              size="extraSmall"
              tag="span"
            >
              Original Equipment Tire
            </Typography>
          )}
        </div>
      </div>
      {showRating && (
        <StarRating
          className={styles['rating']}
          rating={totalRating}
          showRatingNotAvailable
        />
      )}
    </div>
  );
}

export default ProductDescription;
